import React from 'react';
import { motion } from 'framer-motion';
import { Palette, Code, Smartphone, Hexagon, ArrowRight } from 'lucide-react';
import './ServiceCard.css';

const ServiceCard = ({ title, description, icon, technologies }) => {
  const icons = {
    palette: <Palette size={32} />,
    code: <Code size={32} />,
    smartphone: <Smartphone size={32} />,
    hexagon: <Hexagon size={32} />
  };

  return (
    <motion.div 
      className="service-card"
      whileHover={{ y: -8 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
    >
      <div className="service-card-inner">
        <div className="service-header">
          <motion.div 
            className="service-icon"
            whileHover={{ scale: 1.1, rotate: 5 }}
            transition={{ duration: 0.3 }}
          >
            {icons[icon]}
          </motion.div>
          <div className="service-badge">
            <span>Premium</span>
          </div>
        </div>
        
        <div className="service-content">
          <h3 className="service-title">{title}</h3>
          <p className="service-description">{description}</p>
          
          {technologies && (
            <div className="service-technologies">
              <h4>Technologies:</h4>
              <div className="tech-tags">
                {technologies.map((tech, index) => (
                  <span key={index} className="tech-tag">
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="service-footer">
          <motion.button 
            className="service-btn"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Learn More
            <ArrowRight size={16} />
          </motion.button>
        </div>

        <div className="service-glow"></div>
      </div>
    </motion.div>
  );
};

export default ServiceCard;